/**
 * MeslekDuzenleModal.jsx — Kişi Listesi satırından bir kişinin mesleklerini düzenleyen popup (backlog #136, #372, #466)
 *
 * #466 (backend #464): meslek KİŞİNİNDİR — fuardan ve firmadan bağımsız. Popup artık bir (firma, fuar) çiftine konuşmaz, fuar
 * seçili olmasa da açılır; içindeki liste `KisiMeslekleriKarti`dır (aynı kart Kişi Detay'da ve firma sayfasında): meslekler tek
 * tek eklenir (seçici, kategoriye göre gruplu), tek tek kaldırılır, bir firmanın eklediği hafif kuralı olan meslek personelce onaylanır.
 * Her yazma sonrası liste `GET /personnel/{personId}/meslekler`den yeniden okunur; pencere kapanırken (bir şey değiştiyse) çağıran
 * sayfa satırı yeniden çeker (`onSaved`).
 *
 * WAS (until #466): PATCH /personnel/{personId}/meslek { fuarId, meslekIds, firmaId } — o fuardaki işe alımın TÜM kümesini yazan çoklu seçim;
 * kişi o fuarda görevli değilse 400, bu yüzden pencere her zaman tek bir (firma, fuar) çiftini başlıkta gösteriyordu.
 *
 * @param person   Kişi Listesi satırı
 * @param onClose  () => void — hiçbir şey değişmeden kapanış
 * @param onSaved  (personId) => void — en az bir yazmadan sonra kapanış; sayfa satırı yeniden çeker
 */
import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, Alert } from "reactstrap";
import { getKisiMeslekleri } from "../../services/kisiAdminService";
import KisiMeslekleriKarti from "./KisiMeslekleriKarti";
import { useTranslation } from "react-i18next";

export default function MeslekDuzenleModal({ person, onClose, onSaved }) {
  const { t } = useTranslation("components");
  const [meslekler, setMeslekler] = useState(null); // null: okunuyor
  const [yenile, setYenile] = useState(0);
  const [degisti, setDegisti] = useState(false);
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let ignore = false;
    getKisiMeslekleri(person.personId)
      .then((liste) => { if (!ignore) { setMeslekler(liste); setError(null); } })
      .catch((e) => { if (!ignore) { setMeslekler((onceki) => onceki ?? []); setError(e.message || t("meslekDuzenleModal.meslekListesiAlinamadi")); } });
    return () => { ignore = true; };
  }, [person.personId, yenile, t]);

  const kapat = () => (degisti ? onSaved?.(person.personId) : onClose());

  return (
    <Modal isOpen toggle={kapat} centered>
      <ModalHeader toggle={kapat}>{t("meslekDuzenleModal.meslek")}</ModalHeader>
      <ModalBody>
        <div className="mb-3 fw-semibold">{person.name} {person.surname}</div>

        {error && <Alert fade={false} color="danger" className="py-2 small">{error}</Alert>}
        {info && <Alert fade={false} color="success" className="py-2 small">{info}</Alert>}
        {meslekler === null && <div className="text-center py-3"><Spinner color="primary" /></div>}

        {meslekler !== null && (
          <KisiMeslekleriKarti
            bare personId={person.personId} taraf="denetmen" yazabilir meslekler={meslekler}
            onChanged={(msg) => { setInfo(msg); setError(null); setDegisti(true); setYenile((n) => n + 1); }}
            onError={(msg) => { setInfo(null); setError(msg); }}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={kapat}>{t("common:kapat")}</Button>
      </ModalFooter>
    </Modal>
  );
}
